export default __webpack_public_path__ + "static/media/image-npwp.6eda8cac.jpg";